import React from "react";

const TikTokIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M16.6 5.82A4.28 4.28 0 0 1 15.5 3h-3.09v12.4a2.59 2.59 0 1 1-2.59-2.59c.27 0 .53.04.77.12v-3.2a5.8 5.8 0 0 0-.77-.05A5.78 5.78 0 1 0 15.6 15.4V9.01a7.35 7.35 0 0 0 4.3 1.38V7.3a4.28 4.28 0 0 1-3.3-1.48z" />
  </svg>
);
const InstagramIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
    <rect x="2.5" y="2.5" width="19" height="19" rx="5" /><circle cx="12" cy="12" r="4.2" /><circle cx="17.3" cy="6.7" r="1.1" fill="currentColor" stroke="none" />
  </svg>
);
const SnapchatIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12 2c2.7 0 4.5 2 4.6 4.7.02.5 0 1 .03 1.5.4.25.9.2 1.35.02.6-.23 1.2.55.7 1.05-.35.35-.9.5-1.35.7-.3.13-.3.4-.2.68.55 1.5 1.7 2.7 3.2 3.3.5.2.4.9-.1 1.05-.6.18-1.25.2-1.8.5-.15.5.15 1.2-.4 1.45-.55.2-1.15-.15-1.75-.1-.55.05-.95.6-1.5.85-1.15.5-2.5.35-3.6-.2-.4-.2-.85-.2-1.25 0-1.1.55-2.45.7-3.6.2-.55-.25-.95-.8-1.5-.85-.6-.05-1.2.3-1.75.1-.55-.25-.25-.95-.4-1.45-.55-.3-1.2-.32-1.8-.5-.5-.15-.6-.85-.1-1.05 1.5-.6 2.65-1.8 3.2-3.3.1-.28.1-.55-.2-.68-.45-.2-1-.35-1.35-.7-.5-.5.1-1.28.7-1.05.45.18.95.23 1.35-.02.03-.5.01-1 .03-1.5C7.5 4 9.3 2 12 2z" />
  </svg>
);
const FacebookIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M13.5 21v-8h2.6l.4-3h-3V8.1c0-.87.27-1.46 1.5-1.46H17V4.06C16.7 4.02 15.8 4 14.8 4c-2.14 0-3.6 1.3-3.6 3.7V10H8.6v3h2.6v8h2.3z" />
  </svg>
);

const SOCIALS = [
  { name: "TikTok", href: "https://www.tiktok.com/@namarcklimo", icon: <TikTokIcon /> },
  { name: "Instagram", href: "https://www.instagram.com/namarcklimotoronto", icon: <InstagramIcon /> },
  { name: "Snapchat", href: "https://snapchat.com/t/kNwJZvbr", icon: <SnapchatIcon /> },
  { name: "Facebook", href: "https://www.facebook.com/share/1D7up4Zh7J/?mibextid=wwXIfr", icon: <FacebookIcon /> },
];

export const Footer = () => {
  return (
    <footer className="bg-[var(--nl-bg)] border-t border-white/10 pt-24 pb-12" data-testid="footer">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-20">
          <div className="md:col-span-6">
            <div className="flex items-baseline gap-1 mb-6">
              <span className="font-serif text-3xl tracking-tight">Namarck</span>
              <span className="font-serif text-3xl italic text-gold">Limo</span>
            </div>
            <p className="text-white/45 max-w-md font-body font-light text-lg leading-relaxed">
              Ontario's private chauffeur service. Executive sedans and luxury SUVs, driven by professionals who
              understand that the journey is part of the arrival.
            </p>
            <div className="flex items-center gap-4 mt-8" data-testid="footer-socials">
              {SOCIALS.map((s) => (
                <a
                  key={s.name}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.name}
                  data-testid={`social-${s.name.toLowerCase()}`}
                  className="w-11 h-11 flex items-center justify-center border border-white/10 text-white/60 hover:text-gold hover:border-gold transition-colors duration-300"
                >
                  {s.icon}
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-3">
            <p className="label text-gold mb-6">Contact</p>
            <ul className="space-y-3 text-white/60 font-body">
              <li><a href="tel:+12899282427" className="hover:text-gold transition-colors duration-300" data-testid="footer-phone">+1 (289) 928-2427</a></li>
              <li><a href="mailto:admin@namarcklimo.ca" className="hover:text-gold transition-colors duration-300" data-testid="footer-email">admin@namarcklimo.ca</a></li>
              <li>Serving all of Ontario</li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="label text-gold mb-6">Navigate</p>
            <ul className="space-y-3 text-white/60 font-body">
              <li><a href="#fleet" className="hover:text-gold transition-colors duration-300">Fleet</a></li>
              <li><a href="#services" className="hover:text-gold transition-colors duration-300">Services</a></li>
              <li><a href="#book" className="hover:text-gold transition-colors duration-300">Reserve</a></li>
              <li><a href="/rides" className="hover:text-gold transition-colors duration-300" data-testid="footer-rides-link">My Rides</a></li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 pt-8 border-t border-white/10">
          <p className="text-white/30 text-sm font-body">© {new Date().getFullYear()} NamarckLimo. All rights reserved.</p>
          <p className="text-white/30 text-sm font-body">Chauffeured with discretion across Ontario.</p>
        </div>
      </div>
    </footer>
  );
};
